import { CapsuleButton, CapsuleIcon, CapsuleLabel } from './styles';

type ExpandableCapsuleProps = {
  label: string;
  count: number;
  isExpanded?: boolean;
  onToggle?: () => void;
};

export const ExpandableCapsule = ({
  label,
  count,
  isExpanded = false,
  onToggle,
}: ExpandableCapsuleProps) => {
  if (count === 0) return null;

  return (
    <CapsuleButton isExpanded={isExpanded} onClick={onToggle}>
      <CapsuleIcon isExpanded={isExpanded} />
      <CapsuleLabel variant="body2">
        {count} {label}
      </CapsuleLabel>
    </CapsuleButton>
  );
};
